// https://wingo.oss-ap-southeast-7.aliyuncs.com/hau
import axios from "axios";
import { MutableRefObject, Ref, useCallback, useEffect, useMemo, useRef, useState } from "react"; 
import { getCurrentIssueNumber, getNextIssueNumber } from "../utils/util";
import { TabProps } from "../components/LotteryTab";
// import { TabProps } from "@chatui/core";
import sleep from 'sleep-promise'
import _, { StringChain, sortedLastIndex } from 'lodash'
import moment from "moment";
import { calculateWinRate, calculateWinTrend } from "./useDraw";
import stores from "../state";
import { base } from "./usePlanners";
// export const base = 'https://sgp1.vultrobjects.com/lottery-draw/';
// export const base = 'https://wingo.oss-ap-southeast-7.aliyuncs.com/';
// https://oss-ap-southeast-7.aliyuncs.com/wingo/WinGo_30_20241119100051540_planner3_oe_plan


export const useHitRate = ()=>{
    const [data,setData] = useState<{time:string,hitRate:number}[]>();
    const [loadingStatus,setLoadingStatus] = useState(true);
    const loadCallback = useCallback(async ()=>{
        try{
            setLoadingStatus(true)
            const {data} = await axios(base+'hitRate?r='+new Date().getTime())
            setData(data)
            return data
        }catch(e){
            console.error('e',e)
        }finally{
            setLoadingStatus(false)
        }
    },[ ])
    useEffect(()=>{
        loadCallback()
    },[loadCallback])
    return {data,loading:loadingStatus,refresh:loadCallback}
} 
 